module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('header', {
    staticClass: "view__header"
  }, [_c('h2', {
    staticClass: "view__title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('article', {
    staticClass: "view__content"
  }, [_c('div', {
    staticClass: "view__panel"
  }, [_c('div', {
    staticClass: "form js-form"
  }, [_c('submenu'), _vm._v(" "), _c('div', {
    staticClass: "form__image-container"
  }, [_c('img', {
    staticClass: "form__image",
    attrs: {
      "src": _vm.File.getPath(_vm.currentTenant.image)
    }
  })]), _vm._v(" "), _c('TextBox', {
    attrs: {
      "label": "Settings_Group_Name",
      "validate": _vm.$v.tenant,
      "modelPath": "name",
      "acc": "name"
    },
    on: {
      "input": _vm.$v.tenant.name.$touch
    },
    model: {
      value: (_vm.tenant.name),
      callback: function($$v) {
        _vm.$set(_vm.tenant, "name", $$v)
      },
      expression: "tenant.name"
    }
  }), _vm._v(" "), _c('TextBox', {
    attrs: {
      "label": "Settings_Group_Description",
      "validate": _vm.$v.tenant,
      "modelPath": "description",
      "acc": "description"
    },
    on: {
      "input": _vm.$v.tenant.description.$touch
    },
    model: {
      value: (_vm.tenant.description),
      callback: function($$v) {
        _vm.$set(_vm.tenant, "description", $$v)
      },
      expression: "tenant.description"
    }
  }), _vm._v(" "), _c('fieldset', {
    staticClass: "form__field"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "fileUpload"
    }
  }, [_vm._v(_vm._s(_vm.L.localize('Settings_Breadcrumb_Details_Image')))]), _vm._v(" "), _c('input', {
    ref: "fileUpload",
    staticClass: "form__input",
    attrs: {
      "type": "file",
      "accept": "image/*"
    }
  })]), _vm._v(" "), _c('TextBox', {
    attrs: {
      "label": "Settings_Group_BeeClientId",
      "modelPath": "beeClientId",
      "acc": "beeClientId"
    },
    model: {
      value: (_vm.tenant.beeClientId),
      callback: function($$v) {
        _vm.$set(_vm.tenant, "beeClientId", $$v)
      },
      expression: "tenant.beeClientId"
    }
  }), _vm._v(" "), _c('TextBox', {
    attrs: {
      "label": "Settings_Group_BeeClientSecret",
      "modelPath": "beeClientSecret",
      "acc": "beeClientSecret"
    },
    model: {
      value: (_vm.tenant.beeClientSecret),
      callback: function($$v) {
        _vm.$set(_vm.tenant, "beeClientSecret", $$v)
      },
      expression: "tenant.beeClientSecret"
    }
  }), _vm._v(" "), _c('Btn', {
    attrs: {
      "isLoading": _vm.loading,
      "label": "Label_SaveButton"
    },
    on: {
      "click": _vm.save
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1a96f6b8!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/account/Account.vue
// module id = 713
// module chunks = 1